const yellow = {
    100: 'rgb(255, 224, 153)',
    200: 'rgb(255, 212, 112)',
    300: 'rgb(255, 200, 71)',
    400: 'rgb(255, 188, 31)',
    500: 'rgb(245, 171, 0)',
    600: 'rgb(204, 143, 0)',
    700: 'rgb(163, 114, 0)',
    800: 'rgb(122, 86, 0)',
};
export default yellow;
